import {SHOW_DOCUSIGN} from "../actions/actionTypes";

const initialState = {
  show: false,
  callback: null
}

export default function (state = initialState, {type, payload} = {}) {
  if (type === SHOW_DOCUSIGN) {
    return {...state, show: payload.show, callback: payload.callback}
  }
  return state;
}

